<template>
    <div>
        <phoneNav/>
        <div class="activePage-phone">
            <div class="">
                <div class="activePage-banner">
                    <img src="../../assets/images/web/banner-qys.jpg"/>
                </div>
                <div class="act-cont">
                    <Row>
                        <Col span="24">
                            <div class="act-L">
                                <ProjectContPhone :tit="projectTit"
                                             :msg="projectDec"
                                             :subheading="subHeading"/>

                                <div class="act-brand">
                                    <div class="act-tit">品牌活动</div>
                                    <div class="brandList" v-for="(list, index) in actList" :key="index">
                                        <ul>
                                            <li>
                                                <div class="newsImg">
                                                    <img :src="list.newsImg"/>
                                                </div>
                                                <div class="news-con">
                                                    <div class="news-tit">
                                                        {{list.newsTit}}
                                                    </div>
                                                    <div class="news-dec">
                                                        {{list.newsDec}}
                                                    </div>
                                                    <div class="news-date">
                                                        <Row>
                                                            <Col span="12">
                                                                <span>举办周期：</span>{{list.cycle}}
                                                            </Col>
                                                            <Col span="12">
                                                                <span>活动时间：</span>{{list.time}}
                                                            </Col>
                                                            <Col span="12">
                                                                <span>活动规模：</span>{{list.people}}
                                                            </Col>
                                                            <Col span="12">
                                                                <span>参与性质：</span>{{list.participate}}
                                                            </Col>
                                                        </Row>
                                                    </div>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="clubs">
                                    <div class="act-tit">社团</div>
                                    <div class="clubs-catg">
                                        <ul>
                                            <li>
                                                <img src="../../assets/images/web/org01.png"/>
                                                <p>电竞社</p>
                                            </li>
                                            <li>
                                                <img src="../../assets/images/web/org02.png"/>
                                                <p>桌游社</p>
                                            </li>
                                            <li>
                                                <img src="../../assets/images/web/org03.png"/>
                                                <p>烘焙社</p>
                                            </li>
                                            <li>
                                                <img src="../../assets/images/web/org04.png"/>
                                                <p>足球社</p>
                                            </li>
                                            <li>
                                                <img src="../../assets/images/web/org05.png"/>
                                                <p>篮球社</p>
                                            </li>
                                            <li>
                                                <img src="../../assets/images/web/org06.png"/>
                                                <p>读书会</p>
                                            </li>
                                            <li>
                                                <img src="../../assets/images/web/org07.png"/>
                                                <p>相亲会</p>
                                            </li>
                                            <li>
                                                <img src="../../assets/images/web/org08.png"/>
                                                <p>徒步社</p>
                                            </li>
                                            <li>
                                                <img src="../../assets/images/web/org09.png"/>
                                                <p>羽球社</p>
                                            </li>
                                            <li>
                                                <img src="../../assets/images/web/org10.png"/>
                                                <p>戏剧社</p>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="past-active">
                                    <div class="act-tit">往期活动瞬间</div>
                                    <div class="past-active-list">
                                        <Row>
                                            <Col span="8" v-for="(active,index) in pastActive" :key="index">
                                                <div class="t-cont">
                                                    <div class="hdImg"><img :src="active.actImg"/></div>
                                                    <div class="name">{{active.time}}</div>
                                                    <div class="jobtitle">{{active.theme}}</div>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </div>


                        </Col>
                        <Col span="24">
                            <div class="act-R">
                                <Affix :offset-top="70">
                                    <AppointmentR
                                            :msg="appointMsg"
                                            :tit="appointTit"
                                            :recordType="1"
                                            :btnTxt="appointBtnTxt"
                                    />
                                </Affix>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div>
        </div>
        <FooterPhone/>
    </div>
</template>

<script>
    import ProjectContPhone from "../../components/ProjectContPhone";
    import AppointmentR from "../../components/AppointmentR";
    import phoneNav from "../../components/phoneNav";
    import FooterPhone from "../../components/FooterPhone";

    export default {
        name: "QingYunShe",
        components: {
            ProjectContPhone,
            AppointmentR,
            phoneNav,
            FooterPhone
        },
        data() {
            return {
                projectTit: '青云社',
                subHeading: '因青春而云集',
                projectDec: '青云社是由环张江科创团青联盟官方授权“团企联办”、青年自发组成的非营利性组织，是一个因青春而云集的社团活动平台。2015年由盛大发起至今，已有10000+社员组成跨园区、跨企业的张江朋友圈。',

                actList: [
                    {
                        newsTit: '张江青年脑运会',
                        newsDec: '是一场让张江科创青年增加趣味、PK脑力的公益活动！已经与成为每年一度张江青年相聚相知的盛大节日。',
                        newsImg: require('../../assets/images/web/qys-ac1.jpg'),
                        cycle: '一年一度',
                        time: '3月-6月期间',
                        people: '200人左右',
                        participate: '公司报名',

                    },
                    {
                        newsTit: '张江青年运动会',
                        newsDec: '是一场“青春因运动而云集”的运动派对！运动会融合运动、健康、交友、公益于一体，历届活动得到了众多张江企业与青年员工的积极参与。',
                        newsImg: require('../../assets/images/web/qys-ac2.jpg'),
                        cycle: '二年一度',
                        time: '12月份',
                        people: '上千人',
                        participate: '无条件限制',
                    },
                    /*{
                        newsTit: '张江游园会',
                        newsDec: '张江游园会是青云社主办的夏日嘉年华活动，融合游戏、运动、交友、公益于一体，广受好评。',
                        newsImg: require('../../assets/images/web/qys-ac3.jpg'),
                        cycle: '不定期举办',
                        time: '6、7月份',
                        people: '50-100人',
                        participate: '无条件限制',
                    },*/

                ],
                pastActive:[
                    {
                        actImg:require('../../assets/images/web/active-past1.jpg'),
                        time:'2021.10',
                        theme:'第七届张江青年运动会'
                    },
                    {
                        actImg:require('../../assets/images/web/active-past2.jpg'),
                        time:'2020.10',
                        theme:'第六届张江青年运动会'
                    },
                    {
                        actImg:require('../../assets/images/web/active-past3.jpg'),
                        time:'2019.11',
                        theme:'第五届张江青年运动会'
                    },
                    {
                        actImg:require('../../assets/images/web/active-past4.jpg'),
                        time:'2021.10',
                        theme:'健康讲堂活动'
                    },
                    {
                        actImg:require('../../assets/images/web/active-past5.jpg'),
                        time:'2021.11',
                        theme:'青春联谊会'
                    },
                    {
                        actImg:require('../../assets/images/web/active-past6.jpg'),
                        time:'2020.10',
                        theme:'慈善义卖'
                    },
                ],
                appointMsg: '填写您的信息，与我们享受青春。',
                appointTit: '加入社团',
                appointBtnTxt:'立即加入',


            }
        },
    }
</script>

<style lang="less">
    .activePage-phone {
        background-color: #fff;
        width: 100%;
        padding:20px;
        box-sizing:border-box;
        overflow: hidden;
        .activePage-banner{
            margin-top:40px;
            img{
                border-radius:10px;
                width:100%;
            }
        }
        .act-cont {
            margin-top: 15px;

            .act-L {
                /*padding-right: 30px;*/
                .act-tit {
                    font-size: 18px;
                    color: #000;
                    margin-bottom: 10px;
                }

                .act-brand {
                    margin-top: 20px;
                    margin-bottom: 40px;

                    .brandList {

                        ul {
                            li {
                                /*display: flex;*/
                                /*flex-flow: row;*/
                                border: 1px solid #E3E3E3;
                                margin-bottom: 15px;

                                .newsImg {
                                    line-height: 0;
                                    /*flex: 3;*/
                                    img{
                                        width: 100%;
                                        height:100%;
                                    }
                                }

                                .news-con {
                                    /*flex:6;*/
                                    padding: 15px 10px;

                                    .news-tit {
                                        font-size: 16px;
                                        color: #000;
                                        margin-bottom: 5px;
                                    }

                                    .news-dec {
                                        overflow: hidden;
                                        text-overflow: ellipsis;
                                        display: -webkit-box;
                                        -webkit-line-clamp: 2;
                                        -webkit-box-orient: vertical;
                                        margin-bottom: 10px;
                                        color: #999;
                                        font-size: 12px;
                                        height: 36px;
                                    }

                                    .news-date {
                                        color: #333;
                                        font-size: 12px;

                                        span {
                                            color: #999;
                                            display: inline-block;
                                            letter-spacing: -1px;
                                        }
                                    }
                                }
                            }

                            li:hover {
                                border: 1px solid #F5F5F5;
                                box-shadow: 0px 0px 20px 0px rgba(151, 151, 151, 0.5);
                            }
                        }
                    }
                }
                .clubs{
                    margin-bottom:20px;
                    .clubs-catg{
                        ul{
                            width: 100%;
                            display: flex;
                            flex-flow: row;
                            flex-wrap: wrap;
                            li{
                                width: 20%;
                                box-sizing: border-box;
                                text-align: center;
                                margin-bottom: 20px;
                                img{
                                    width:60%;
                                }
                                p{
                                    padding-top:10px;
                                }
                            }
                            li::marker{
                                content: '';
                            }
                            li:hover{
                                transform:scale(1.1,1.1);
                                -webkit-transition: all 0.3s ease-in-out 0s;
                                -moz-transition: all 0.3s ease-in-out 0s;
                                -o-transition: all 0.3s ease-in-out 0s;
                                -ms-transition: all 0.3s ease-in-out 0s;
                                transition: all 0.3s ease-in-out 0s;
                                img{
                                    border-radius:50%;
                                    -moz-box-shadow:1px 1px 3px rgba(0, 102, 204, 0.55);
                                    -webkit-box-shadow:1px 1px 3px rgba(0, 102, 204, 0.55);
                                    box-shadow:1px 1px 3px rgba(0, 102, 204, 0.55);

                                }
                                p{
                                    color:#3376FE;
                                }
                            }
                        }
                    }
                }
                .past-active{
                    .past-active-list {
                        .ivu-row {
                            margin: 0 -10px;

                            .ivu-col {
                                text-align: center;
                                margin-bottom:20px;
                                .t-cont {
                                    margin: 0 10px;
                                    border: 1px solid #E3E3E3;
                                    box-shadow: 0px 0px 1px 0px rgba(151, 151, 151, 0.5);
                                    border-radius: 5px;

                                    .hdImg {
                                        height: 100px;
                                        background-color: #CFCFCF;
                                        border-radius: 5px;

                                        img {
                                            width: 100%;
                                            height: 100%;
                                            border-radius: 5px;
                                            overflow: hidden;
                                        }

                                    }

                                    .name {
                                        font-size: 16px;
                                        color: #666;
                                        padding: 10px 0 5px 0;
                                    }

                                    .jobtitle {
                                        padding-bottom: 8px;
                                        font-size: 12px;
                                        color: #999;
                                        height: 40px;
                                    }
                                }
                                .t-cont:hover{
                                    box-shadow: 0px 5px 10px 0px rgba(18, 59, 89, 0.19);
                                }
                            }
                        }
                    }
                }


            }
        }
    }


</style>